import axios from "axios";
import { stringify } from "qs";
import merge from "lodash/merge";
import { clearLoginInfo } from "./index";
import VueCookie from "vue-cookie";

function createHttp(Vue, config = { httpRequestUrl: "", fileUploaderUrl: "", appName: "" }) {
  const http = axios.create({
    timeout: 1000 * 30,
    //withCredentials: true,
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
  });
  const appName = config.appName || VueCookie.get("appName");
//   if (config.httpRequestUrl) {
//     //判断是否传入
//     console.log("【ace-ui】现在使用的请求地址是：http://" + config.httpRequestUrl + "。如果要发布生产环境，请在编译打包前删除此URL配置。");
//   }
//   if (config.fileUploaderUrl) {
//     console.log("【ace-ui】现在使用的文件上传地址是：http://" + config.fileUploaderUrl + "/fileserver/。如果要发布生产环境，请在编译打包前配置生产环境下的地址");
//   }
  //HTTP 请求地址
  const httpRequestUrl = config.httpRequestUrl ? "http://" + config.httpRequestUrl : window.location.origin;
  //文件上传地址
  const fileUploaderUrl = config.fileUploaderUrl ? "http://" + config.fileUploaderUrl + "/fileserver/" : window.location.origin + "/fileserver/";
  //应用请求地址
  const appRequestUrl = httpRequestUrl + "/" + appName;
  /**
   * 请求拦截
   */
  http.interceptors.request.use(
    (config) => {
      config.headers["token"] = VueCookie.get("token"); // 请求头带上token
      return config;
    },
    (error) => {
      console.error("【请求处理发生错误】br/", error);
      return Promise.reject(error);
    }
  );

  /**
   * 响应拦截
   */
  http.interceptors.response.use(
    (response) => {
      if (response.data && response.data.code === 405) {
        // 用户操作超时
        // window.postMessage('showLoginDiag')
        return false;
      } else if (response.data && response.data.code === 40001) {
        // 401, token失效
        if (config.needLogin) {
          clearLoginInfo();
          window.location.href = window.location.origin;
        }
      }
      return response;
    },
    (error) => {
      console.error("【响应处理发生错误】br/", error);
      return Promise.reject(error);
    }
  );

  /**
   * 请求地址处理
   * @param {*} actionName action方法名称
   */
  /**
   * 请求地址处理
   * @param {*} actionName action方法名称
   */
  http.adornUrl = (actionName, appName = "platform") => {
    if (appName == "false" || appName === false) {
      return httpRequestUrl + actionName;
    }
    return httpRequestUrl + "/" + appName + actionName;
  };

  http.adornFileUploaderUrl = (actionName, paramsQuery) => {
    let url = httpRequestUrl + "/fileserver/" + actionName + "?appName=" + appName + "&token=" + VueCookie.get("token");
    if (paramsQuery === undefined) {
      return url;
    }
    return url + "&" + paramsQuery;
  };

  http.adornMessagerUrl = (actionName) => {
    return httpRequestUrl + actionName + "?token=" + VueCookie.get("token");
  };

  http.getRequestProjectUrl = () => {
    let host = self.location.host; //路径（域名）
    let http = self.location.protocol;
    let url = http + "//" + host;
    return url;
  };

  /**
   * get请求参数处理
   * @param {*} params 参数对象
   * @param {*} openDefultParams 是否开启默认参数?
   */
  http.adornParams = (params = {}, openDefultParams = false) => {
    var defaults = {
      aceTimestamp: new Date().getTime(),
    };
    return openDefultParams ? merge(defaults, params) : params;
  };
  http.adornWorkFlowUrl = (actionName, hasAppName = false) => {
    if (hasAppName) {
      return httpRequestUrl + "/" + actionName;
    } else {
      return httpRequestUrl + "/" + appName + "/" + actionName;
    }
  };
  /**
   * post请求数据处理
   * @param {*} data 数据对象
   * @param {*} openDefultdata 是否开启默认数据?
   * @param {*} contentType 数据格式
   *  json: 'application/json; charset=utf-8'
   *  form: 'application/x-www-form-urlencoded; charset=utf-8'
   */
  http.adornData = (data = {}, openDefultdata = false, contentType = "json") => {
    var defaults = {
      aceTimestamp: new Date().getTime(),
    };
    data = openDefultdata ? merge(defaults, data) : data;
    return contentType === "json" ? JSON.stringify(data) : stringify(data);
  };
  Vue.prototype.$http = http;
}

export default createHttp;
